import request from 'local_modules/request'
import actions from 'redux/actions'
import { reducers, getState } from 'redux/core'
import { modals, constants, convertPrice } from 'helpers'


const setFetching = (isFetching) => reducers.marketplace.adminLearnTariffPage.setFetching(isFetching)

const setTariffs = (tariffs) => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  const _tariffs = convertPrice.fromRub(tariffs)

  return request.post(constants.marketplace.learnTariff + `/${tool}`, _tariffs)
    .then(({ data }) => data)
    .catch((error) => {
      actions.modals.open(modals.Dialog, {
        title: 'Ошибка',
        text: JSON.stringify({ error })
      })
      console.log(error)
    })
}

const fetchTariffs = () => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.learnTariff + `/${tool}`)
    .then(({ data }) => data)
    .then((data) => {
      const tariffs = convertPrice.toRub(data || [])

      reducers.marketplace.adminLearnTariffPage.setTariffs(tariffs)
    })
    .catch((error) => console.log(error))
}



export default {
  setFetching,
  fetchTariffs,
  setTariffs,
}
